var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0017 2.88208L22.2378 8.00011L12.0017 13.1181L1.76564 8.00011L12.0017 2.88208ZM6.23778 8.00011L12.0017 10.8821L17.7656 8.00011L12.0017 5.11815L6.23778 8.00011Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2378 12.0001L12.0017 17.1181L1.76562 12.0001L4.00168 10.8821L12.0017 14.8821L20.0017 10.8821L22.2378 12.0001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2378 16.0001L12.0017 21.1181L1.76562 16.0001L4.00168 14.8821L12.0017 18.8821L20.0017 14.8821L22.2378 16.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIcon);
export default __webpack_public_path__ + "static/media/StackIcon.46f1eb3c14b74205e9e335c1d60f6b83.svg";
export { ForwardRef as ReactComponent };